export default {
  title: 'Tem a certeza?',
  description: 'Os seguintes grupos de modificadores (incluindo os respetivos modificadores) serão eliminados:',
  buttons: {
    yes: 'Sim',
    no: 'Não',
  },
  toasts: {
    modifier_group_got_deleted: 'Grupos de modificadores eliminados',
    failed_to_delete_modifier_group: 'Falha ao eliminar o grupo de modificadores',
  },
};
